import Modal from "../../../../../assets/es6/common/classes/modal.es6";
import Goods from "./goods.es6";

function setAnimeClass() {
    // アニメーション終了時にループクラスを付与
    const watchAnimationedEle = document.querySelectorAll("[data-animationed]");
    for (const ele of watchAnimationedEle) {
        ele.addEventListener("animationend", () => {
            ele.classList.add("-loop");
        });
    }

    const targets = document.querySelectorAll("[data-observed]");
    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    // 要素が少しでも見えたらトリガー
                    entry.target.classList.add("-visible");
                    observer.unobserve(entry.target);
                }
            }
        },
        {
            // NOTE: チケットブロックの高さが可変でIntersectionObserverのthreshold条件が満たされないためトリガー条件を緩める
            threshold: [0],
        }
    );

    for (const target of targets) {
        observer.observe(target);
    }

    const fvEle = document.querySelectorAll("[data-fv]");
    for (const ele of fvEle) {
        setTimeout(() => {
            ele.classList.add("-visible");
        }, 300);
    }
}

function shareSwitch() {
    //コンテンツ内SHAREをスクロール一番上の時は非表示に
    const share = document.querySelector(".js-share");

    window.addEventListener("scroll", () => {
        const scrollY = window.scrollY;
        if (scrollY > 0) {
            share.classList.add("-active");
            share.classList.remove("-off");
        } else {
            share.classList.add("-off");
            share.classList.remove("-active");
        }
    });
}

// function Accordion() {
//     document.addEventListener("DOMContentLoaded", () => {
//         const accTriggers = document.querySelectorAll(".js-acc_trigger");
//
//         accTriggers.forEach((trigger) => {
//             trigger.addEventListener("click", () => {
//                 const acc = trigger.nextElementSibling; // 対応する js-acc 要素
//                 const isActive = trigger.classList.contains("-active");
//
//                 if (isActive) {
//                     // アコーディオンを閉じる
//                     acc.style.height = "0px";
//                     trigger.classList.remove("-active");
//                 } else {
//                     // アコーディオンを開く
//                     acc.style.height = `${acc.scrollHeight}px`;
//                     trigger.classList.add("-active");
//                 }
//             });
//         });
//     });
// }

function Accordion() {
    const accTriggers = document.querySelectorAll(".js-acc_trigger");

    accTriggers.forEach((trigger) => {
        const acc = trigger.nextElementSibling;
        const accInner = acc.querySelector(".js-acc_cont");

        // 初期化: 内部コンテンツの高さを取得して設定
        setTimeout(() => {
            const contentHeight = accInner.scrollHeight;
            acc.style.height = `${contentHeight}px`;
            trigger.classList.add("-active");

            if (trigger.classList.contains("-end")) {
                trigger.classList.remove("-active");
                acc.style.height = "0px";
            }
        }, 600); // ブラウザのレンダリングが完了した後に高さを設定するために少し待つ

        trigger.addEventListener("click", () => {
            const isActive = trigger.classList.contains("-active");

            if (isActive) {
                // アコーディオンを閉じる
                acc.style.height = "0px";
                trigger.classList.remove("-active");
            } else {
                // アコーディオンを開く
                const newHeight = accInner.scrollHeight;
                acc.style.height = `${newHeight}px`;
                trigger.classList.add("-active");
            }
        });
    });
}

function setGoodsModal() {
    const goods = new Goods();
    const modal = new Modal();
}

document.addEventListener("DOMContentLoaded", () => {
    setAnimeClass();
    shareSwitch();
    Accordion();
    setGoodsModal();
});
